module.exports = __webpack_public_path__ + "img/comp.48500481.png";